$(document).ready(() => {
    const $imageRotator = $('.image-rotator')
    if ($imageRotator.length && $('.image-rotator__image', $imageRotator).length) {
        // initialize slick image rotator and pause
        const imageRotator = $imageRotator.slick({
            accessibility: false,
            autoplay: true,
            autoplaySpeed: $imageRotator.data('rotator-interval') || 5000,
            arrows: false,
            dots: false,
            fade: true,
            swipe: false,
            draggable: false,
            touchMove: false,
            pauseOnFocus: false,
            pauseOnHover: false,
            lazyLoad: true,
        }).slick('slickPause')
        // check for visibility and play or pause
        $(window).on('load resize scroll', () => {
            if ($imageRotator.isInViewport()) {
                imageRotator.slick('slickPlay')
            } else {
                imageRotator.slick('slickPause')
            }
        })
    }
})